import { readSdxValue } from "../../../utils/sdxHelpers";

export default function YearDropdown({ years, value, onChange, isMobile }) {
  if (!years?.length) return null;

  return (
    <div style={{ minWidth: isMobile ? 136 : 150 }}>
      <sdx-select
        aria-label="Reporting-Jahr auswählen"
        onInput={(event) => onChange?.(Number(readSdxValue(event)))}
      >
        {years.map((year) => (
          <sdx-select-option key={year} value={String(year)} selected={year === value}>
            {year}
          </sdx-select-option>
        ))}
      </sdx-select>
    </div>
  );
}
